import App from "./App";
import React, { lazy, Suspense } from "react";
import store from "./store";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import Header from "./layout/Header";
import "./styles/design-system.css";
import "./responsive.css";
import { loadBootstrapCss, loadLegacyAppCss } from "./styles/loadDeferredStyles";
import { ConsAIAssistantProvider } from "./components/guide/ConsAIAssistantContext";
import { installAuthInterceptor } from "./config/authInterceptor";
import { PermissionProvider } from "./config/permissions";

installAuthInterceptor();

const WhatsAppWidget = lazy(() => import("./components/Whatsapp"));
const ConsAIAssistant = lazy(() => import("./components/guide/ConsAIAssistant"));

function scheduleDeferredStyles() {
  const run = () => {
    loadBootstrapCss();
    loadLegacyAppCss();
  };
  if (typeof window !== "undefined" && "requestIdleCallback" in window) {
    window.requestIdleCallback(run, { timeout: 2500 });
  } else {
    setTimeout(run, 1200);
  }
}

scheduleDeferredStyles();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Provider store={store}>
      <ConsAIAssistantProvider>
      <PermissionProvider>
      <Header />
      <Suspense fallback={null}>
        <WhatsAppWidget />
        <ConsAIAssistant />
      </Suspense>
      <div className="main-container">
        <App />
      </div>
      </PermissionProvider>
      </ConsAIAssistantProvider>
    </Provider>
  </BrowserRouter>,
);

reportWebVitals();
